// src/pages/user/Dashboard.js
import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { FiUser, FiShoppingBag, FiHeart, FiSettings } from 'react-icons/fi';

import Profile from './Profile';
import Orders from './Orders';
import Vouchers from './Vouchers';
import Favorites from './Favorites';

const Dashboard = () => {
  const location = useLocation();

  const menuItems = [
    { path: '/dashboard', label: 'Mon profil', icon: FiUser },
    { path: '/dashboard/orders', label: 'Mes commandes', icon: FiShoppingBag },
    { path: '/dashboard/vouchers', label: 'Mes vouchers', icon: FiSettings },
    { path: '/dashboard/favorites', label: 'Mes favoris', icon: FiHeart }
  ];

  // Fonction d’activation robuste
  const isMenuActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold mb-8">Mon Compte</h1>

      <div className="grid md:grid-cols-4 gap-6">
        
        {/* Menu latéral */}
        <div className="md:col-span-1">
          <div className="bg-white rounded-lg shadow p-4">
            <nav className="space-y-2">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const active = isMenuActive(item.path);

                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-all ${
                      active
                        ? 'bg-primary-50 text-primary-600 font-semibold shadow-sm'
                        : 'text-gray-700 hover:bg-gray-50 hover:shadow-sm'
                    }`}
                  >
                    <Icon size={20} />
                    <span>{item.label}</span>
                  </Link>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Contenu */}
        <div className="md:col-span-3">
          <div className="bg-white rounded-lg shadow p-6">
            <Routes>
              <Route index element={<Profile />} />
              <Route path="orders" element={<Orders />} />
              <Route path="vouchers" element={<Vouchers />} />
              <Route path="favorites" element={<Favorites />} />
            </Routes>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Dashboard;
